import { render, staticRenderFns } from "./leaderlist.vue?vue&type=template&id=665d78bc&scoped=true"
import script from "./leaderlist.vue?vue&type=script&lang=js"
export * from "./leaderlist.vue?vue&type=script&lang=js"
import style0 from "./leaderlist.vue?vue&type=style&index=0&id=665d78bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665d78bc",
  null
  
)

export default component.exports